<template>
  <div
      v-if="event"
  >
      <HtmlText tag="h2" :text="$t('chooseYourZone')" class="mt-3 mb-4"></HtmlText>

      <ul class="zone-list list-group pt-2">
        <li class="list-group-item d-flex justify-content-between align-items-center"
            v-for="zone in event.zones"
            v-bind:key="zone"
            @click="setZone(zone)"
        >
            {{ zone }}
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/></svg>
        </li>
      </ul>

      <booking-summary
          :event="event"
          :booking="booking"
      ></booking-summary>
  </div>
</template>

<script>
import BookingSummary from '../components/BookingSummary';
import HtmlText from '../components/HtmlText';
import translationMixin from '../mixins/translationMixin';
import eventBus from '../eventBus';

export default {
  mixins: [translationMixin],

  components: {
    BookingSummary,
    HtmlText
  },

  props: [
    'event',
    'booking'
  ],

  methods: {
    /**
     * Set the zone and proceed.
     *
     * @param {String} zone
     */
    setZone(zone) {
      this.booking.preferred_zone = zone;
      this.booking.can_select_zone = true;

      // Trigger a reload of event to get zone capacity
      eventBus.$emit('reloadEvent');

      // To periods/lockers
      this.$router.push('/event/' + this.event.code);
    }
  }
}
</script>
